import axios from 'axios';
import * as types from './index';
export const getProfile = () => async (dispatch) => {
  try {
    const res = await axios.get('https://ncode-backend.herokuapp.com/profile', {
      headers: { 'x-auth-token': localStorage.token },
    });
    dispatch({
      type: types.GET_PROFILE,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: types.PROFILE_ERROR,
      payload: { msg: error.response.statusText, status: error.response.status },
    });
  }
};

export const updateProfile = (newProfile) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const res = await axios.put('https://ncode-backend.herokuapp.com/profile', newProfile, config);
    dispatch({
      type: types.GET_PROFILE,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: types.PROFILE_ERROR,
      payload: { msg: error.response.statusText, status: error.error.status },
    });
  }
};
